import { IS_BASE, IS_DUAL, IS_ELEC, IS_GAS, IS_HP_HC, WORKFLOW_EDISON } from '../../../../SubscriptionForm/Common/constants'

// todo-v2: clean the data and put only needed ones
export const amountParametersGeneration = ({
  workflowName,
  contractId,
  country,
  contactId,
  activeAddress,
  activeCharacteristics,
  activeContractDetails,
  contactPreferences,
  consumptionData,
  offerConfig,
  activeElecData,
  billingData,
  identityContact,
  personalContactData,
  gasData,
}) => {
  const {
    city,
    cityId,
    inseeCode,
    zipcode,
    surface,
    heatingEnergy,
    hotwaterEnergy,
    electricityMeter,
    gasMeter,
    isResident,
    lastHolderData,
  } = activeAddress || {}
  const { last_holder_name: lastHolderName, last_holder_cf: lastHolderCf } = lastHolderData || {}
  const { prestationType, energyType } = activeCharacteristics || {}
  const { offerId } = activeContractDetails || {}
  const { clientType } = contactPreferences || {}
  const { comparator_id: comparatorId } = offerConfig || {}
  const { carBase, carHp, carHc, carGas } = consumptionData || {}

  const options = {}
  options.workflowName = workflowName || (country === 'it' ? 'default' : '')
  options.contract_id = contractId || ''
  options.contact_id = contactId ? parseInt(contactId, 10) : undefined
  options.country = country || ''
  options.city_id = inseeCode || ''
  options.zipcode = zipcode || ''
  options.city = city || ''
  options.prestation_type = prestationType || ''
  options.energy_type = energyType || ''
  options.contract_type = clientType || ''
  options.offer_id = offerId ? parseInt(offerId) : ''
  options.comparator_id = comparatorId || ''

  if (energyType === IS_DUAL || energyType === IS_ELEC) {
    const { meterOption, meterPower } = activeElecData || {}
    const { pdlNo } = electricityMeter || {}
    options.meter_power_elec = meterPower || ''
    options.meter_option_elec = meterOption || ''
    options.meter_id_elec = pdlNo || ''

    if (meterOption === IS_BASE) {
      options.car_elec_base = carBase || 0
    }
    if (meterOption === IS_HP_HC) {
      options.car_elec_hp = carHp || 0
      options.car_elec_hc = carHc || 0
    }
  }

  if (energyType === IS_DUAL || energyType === IS_GAS) {
    const { pceNo } = gasMeter || {}
    options.meter_id_gas = pceNo || ''
    options.car_gas = carGas || 0
  }

  options.surface = surface || null
  options.hotwater_energy = hotwaterEnergy || ''
  options.heating_energy = heatingEnergy || ''

  if (country === 'it') {
    options.city_id = cityId || (workflowName === WORKFLOW_EDISON ? '123' : '')
    options.is_resident = isResident ? 1 : 0
    if (energyType === IS_DUAL || energyType === IS_ELEC) {
      options.usage_type_elec = activeElecData?.usage || ''
      if (workflowName === WORKFLOW_EDISON) {
        options.meter_type_elec = activeElecData?.meterType || ''
        options.origin_market_elec = activeElecData?.originMarket || ''
      }
      if (activeElecData.meterOption === IS_BASE) {
        options.italy_consumption_base = consumptionData.consumptionBase || 0
      }
      if (activeElecData.meterOption === IS_HP_HC) {
        options.italy_consumption_f1 = consumptionData.consumptionBiorariaF1 || 0
        options.italy_consumption_f2 = consumptionData.consumptionBiorariaF2 || 0
        options.italy_consumption_f3 = consumptionData.consumptionBiorariaF3 || 0
      }
    }
    if (energyType === IS_DUAL || energyType === IS_GAS) {
      if (gasData.meterType) {
        options.meter_type_gas = gasData.meterType || ''
      }
      if (workflowName === WORKFLOW_EDISON) {
        options.distributor_code_gas = gasData.distributorCode || ''
      }
      options.usage_type_gas = gasData.usage || ''
    }
    options.payment_mode = billingData.paymentMode || ''
    options.invoice_frequency = billingData.frequency || ''
    options.tax_id_code = identityContact.taxIdCode ?? ''
    options.firstname = personalContactData.firstName ?? ''
    options.lastname = personalContactData.lastName ?? ''
    options.birthdate = personalContactData.birthdate ?? ''
    options.street_name = activeAddress.streetName || ''
    options.street_number = activeAddress.streetNumber || ''
    options.province = activeAddress.province || ''
    if (lastHolderName) options.last_holder_name = lastHolderName
    if (lastHolderCf) options.last_holder_cf = lastHolderCf
  }

  /*
  options.append('zoho_id', customerData.zohoId)
  options.append('conso_residence_type', mainAddressData.residenceType ?? '-1')
  options.append('housing_type', mainAddressData.housingType ?? '')
  options.append('organisation_id', energyContractData.providerId ? parseInt(energyContractData.providerId) : '')
  options.append('is_debordement', energyContractData.isDebordement ?? '0')
  options.append('payment_mode_real', billingData.realPayment ?? '')
  options.append('mes_emergency', energyContractData.mesEmergency ?? '')
  options.append('cooking_energy', energyConsumptionData.cooking)
  */
  return options
}
